<template>
    <v-container fluid align-start ma-0 pa-2 class="container-height">
      <v-row no-gutters fill-height>
        <v-col cols="12">
          <i-card-vertical :headerTitle="menuTitle" >
            <template v-slot:body>
                <v-row>
                  <v-col cols="12" class="pa-0">
                    <i-card-top
                      class="d-md-flex"
                      outlined
                      :useBtnList="useBtnList"
                      @btnRetrieve="btnRetrieve()" @btnSaveRequest="btnSaveRequest()"
                    >
                      <template v-slot:body>
                        <v-row no-gutters class="center pa-2 pb-0">
                          <i-label :label="'Ship No : '" class="pl-2"/>
                          <v-col cols="2">
                            <v-select
                              v-model="shipNo"
                              :items="shipNoList"
                              item-value="shipNo"
                              return-object
                              single-line
                              outlined
                              dense
                              @change="btnRetrieve"
                            ></v-select>
                          </v-col>
                        </v-row>
                      </template>
                    </i-card-top>
                  </v-col>
                </v-row>
  
                <v-row no-gutters>
                  <v-col cols="12" class="pt-1">
                    <DxDataGrid id="epms6200" 
                      :ref="epms6200Ref"
                      class="hipGridHeight1_1"
                      :data-source="gridMainList" 
                      :remote-operations="false" 
                      :hover-state-enabled="true"
                      :allow-column-resizing="true" 
                      :allow-column-reordering="true"
                      :row-alternation-enabled="true" 
                      :show-borders="true" 
                      :width="grid.width"
                      :show-row-lines="true" 
                      key-expr="id" 
                      :focused-row-enabled="true"
                      :column-hiding-enabled="false" 
                      :sorting="{ mode: 'none' }"
                      @cellPrepared="cellPrepared"
                    >
                      <DxEditing :use-icons="true" />
                      <DxColumn data-field="rnum" caption="No" width="3%" data-type="number" format="0,###" alignment="center" :allow-editing="false"/>
                      <DxColumn data-field="drumNo" caption="DRUM NO." width="10%" data-type="string" alignment="center" :allow-editing="false" />
                      <DxColumn data-field="cableType" caption="TYPE" width="10%" data-type="string" alignment="center" :allow-editing="false" />
                      <DxColumn data-field="totLeng" width="10%" data-type="number" alignment="right" format="#,###" header-cell-template="totalMr" :allow-editing="false" />
                      <template #totalMr>
                        <div>TOTAL<br>MR</div>
                      </template>
                      <DxColumn data-field="reqDte" width="10%" data-type="string" alignment="center" header-cell-template="payDate" :allow-editing="false" />
                      <template #payDate>
                        <div>Pay Request<br>Date</div>
                      </template>
                      <DxColumn data-field="uprice" width="10%" data-type="number" alignment="right" format="#,###" header-cell-template="unitPrice" :allow-editing="false" />
                      <template #unitPrice>
                        <div>Unit<br>Price</div>
                      </template>
                      <DxColumn data-field="vat" caption="VAT" width="10%" data-type="string" alignment="center" :allow-editing="false" />
                      <DxColumn data-field="amt" caption="Amount" width="10%" data-type="number" alignment="right" format="#,###" :allow-editing="false" />
                      <DxColumn data-field="vatAmt" caption="VAT Amount" width="10%" data-type="number" alignment="right" format="#,###" :allow-editing="false" />
                      <DxColumn data-field="totAmt" width="17%" data-type="number" alignment="right" format="#,###" header-cell-template="totalAmount" :allow-editing="false" />
                      <template #totalAmount>
                        <div>Total<br>Amount</div>
                      </template>
                      <DxPaging :enabled="true" :page-size="20" />
                      <DxSummary>
                        <DxTotalItem
                          column="rnum"
                          summary-type="sum"
                          display-format="Need to pay"
                        />
                        <DxTotalItem
                          column="totLeng"
                          summary-type="sum"
                          :customize-text="totLeng"
                        />
                        <DxTotalItem
                          column="reqDte"
                          summary-type="sum"
                          display-format="Price:"
                          alignment="left"
                        />
                        <DxTotalItem
                          column="uprice"
                          summary-type="sum"
                          :display-format="uprice"
                        />
                        <DxTotalItem
                          column="vat"
                          summary-type="sum"
                          :display-format="vat"
                        />
                        <DxTotalItem
                          column="amt"
                          summary-type="sum"
                          :customize-text="totLeng"
                        />
                        <DxTotalItem
                          column="vatAmt"
                          summary-type="sum"
                          :customize-text="totLeng"
                        />
                        <DxTotalItem
                          column="totAmt"
                          summary-type="sum"
                          :customize-text="totLeng"
                        />
                      </DxSummary>
                    </DxDataGrid>
                  </v-col>
                </v-row>
  
            </template>
          </i-card-vertical>
        </v-col>
      </v-row>
    </v-container>
  </template>
  
  <script>
  import { DxDataGrid, DxEditing, DxColumn , DxSummary , DxTotalItem } from 'devextreme-vue/data-grid'
  import ICardVertical from '@/components/common/iCardVertical.vue'
  import iCardTop from '@/components/common/iCardTop.vue'
  import baseview from '@/components/base/baseview.vue' // base page 추가
  import BaseDataGrid from '@/components/base/BaseDataGrid.vue' // 데이타 그리드 사용시 베이스 추가
  import { getShipList } from '@/api/view/hip/6/epms6400.js'
  import { getPaymentList , epms6200Save } from '@/api/view/hip/6/epms6200.js'
  import notify from 'devextreme/ui/notify' // message
  import { getNumComma , getCurrentDate} from '@/utils/common.js'
  
  export default {
    name: 'epms6200',
    mixins: [baseview, BaseDataGrid],
    components: {
      ICardVertical,
      'i-card-top': iCardTop,
      DxDataGrid,
      DxColumn,
      DxEditing,
      DxSummary,
      DxTotalItem
    },
    data() {
      return {
        menuTitle: this.$route.meta.title,
        useBtnList: ['btnRetrieve' ,'btnSaveRequest'],
        epms6200Ref: 'epms6200Ref',
        gridMainList: [],
  
        shipNo: '',
        shipNoList: [],

        uprice: '0',
        vat: '0'
        
      }
    },
    computed: {
      gridMainInstance() {
        return this.GetDataGrid(this.epms6200Ref)
      },
    },
    mounted() {
      this.shipList()
      this.getList()
    },
    methods: {
      totLeng(data){
        return getNumComma(data.value)
      },
      async shipList(){
        try {
          this.openLoading('searching')
          let params = {
            makerCd: this.$store.state.user.makerCd,
          }
          await getShipList(params).then(res => {
            res.list.forEach(e => {
              this.shipNoList.push(e.shipNo)
            });
          })
        } finally {
        this.endLoading()
        }
      },
      async getList(){
        try {
          this.openLoading('searching')
          let params = {
            // shipNo: 'S10006',
            // makerCd: '',
            shipNo: this.shipNo,
            makerCd: this.$store.state.user.makerCd,
          }
          await getPaymentList(params).then(res => {
            if(res.list.length){
              res.list.forEach(e => {
                e.id = e.rnum
              if(e.reqPay === 'Y'){
                this.gridMainInstance.selectRows([e.id], true)
              }
              });
              this.uprice = getNumComma(res.list[0].uprice)
              this.vat = getNumComma(res.list[0].vat)
              this.gridMainList = res.list
            }
          })
  
        } finally {
        this.endLoading()
        }
      },
      btnRetrieve(){
        this.getList()
      },
      async btnSaveRequest(){
        if(!this.shipNo || this.shipNo === ''){
          return
        }
        await this.gridMainInstance.saveEditData()
        var selectedMainRows = await this.gridMainInstance.getSelectedRowsData()
        let praams = []
        selectedMainRows.forEach(e => {
          if(e.reqPay !== 'Y'){
            praams.push({
              uprice: e.uprice, vat: e.vat , shipNo: e.shipNo, drumNo: e.drumNo, makerCd: this.$store.state.user.makerCd
            })
          }
        });
        try {
          this.openLoading()
          this.gridMainInstance.beginUpdate()
          epms6200Save(praams)
            .then(res => {
              notify(this.$t('Save'), 'success', 3000)
              this.getList()
            })
          } finally {
            this.gridMainInstance.endUpdate()
            this.endLoading()
          }
      },
      cellPrepared(e){
        if(e.rowType === 'totalFooter'){
          e.cellElement.style.borderRight = '1px solid gray'
          this.merge(e)
        }
      },
      merge(e){
        if(e.columnIndex == '1'){
          e.cellElement.setAttribute('colspan' , 3)
        } else if(e.columnIndex == '2' || e.columnIndex == '3'){
          e.cellElement.style.display = 'none'
        } else if(e.columnIndex == '0' || e.columnIndex == '5' || e.columnIndex == '6'){
          e.cellElement.style.borderRight = '0'
        }
      }
    }
  }
  </script>
  <style lang="scss" scoped>
  </style>